import React from 'react';
import { Link } from 'react-router'
import { connect } from 'react-redux'

import { Logo, MenuMain } from './MenuMain'
import AuthLinks from './Auth'
import { SearchForm }from './Search'


function mapStateToProps(state) {
  return {
    browser: state.browser
  }
}

@connect(mapStateToProps, {})
class Header extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    const { browser } = this.props

    const menu = <MenuMain location={this.props.location} />
    let headerItems = (<div className="headerItems"> <AuthLinks applyOrganization = {this.props.applyOrganization} /> </div>)
    if (browser.greaterThan.desktop) {
      headerItems = (
        <div className="headerItems">
          <div className="left"><Logo /></div>
          <div className="right">
            <AuthLinks applyOrganization = {this.props.applyOrganization} />
            <SearchForm />
          </div>
        </div>
      )
    }
    return (
      <header>
          {headerItems}
        <div className="menuContainer">{menu}</div>
      </header>
    )
  }
}

export default Header



// WEBPACK FOOTER //
// ./src/components/header/Header.jsx